






import { Component, Vue } from "vue-property-decorator";
@Component({
  props: {
    copyright: String,
  },
})
export default class Footer extends Vue {}
